import React, { Component } from "react";
import { Row, Col } from "react-flexbox-grid";
import Icon from "material-ui-next/Icon";
import { DescriptionField, If } from "components/support";
import style from "./style";

class CompanyGeneralInfo extends Component {
  render() {
    const { company, currentUser, className } = this.props;
    const fiscal_informations = company.fiscal_informations || {};

    return (
      <div className={`${className} grid-container`}>
        <If test={currentUser.is_admin}>
          <Row>
            <Col xs={12}>
              <If test={company.blocked}>
                <div className="informations">
                  <div>
                    <Icon style={{ padding: "2px 0px 0px", color: "red" }}>
                      close
                    </Icon>
                  </div>
                  <div className="message">Empresa Bloqueada</div>
                </div>
              </If>

              <If test={!company.blocked}>
                <div className="informations">
                  <div>
                    <Icon style={{ padding: "2px 0px 0px", color: "green" }}>
                      done
                    </Icon>
                  </div>
                  <div className="message">Empresa Ativa</div>
                </div>
              </If>
            </Col>
          </Row>
        </If>
        <Row>
          <Col xs={12} sm={6} md={3}>
            <DescriptionField
              label="CNPJ"
              value={fiscal_informations.cnpj}
              mask={[
                /\d/,
                /\d/,
                ".",
                /\d/,
                /\d/,
                /\d/,
                ".",
                /\d/,
                /\d/,
                /\d/,
                "/",
                /\d/,
                /\d/,
                /\d/,
                /\d/,
                "-",
                /\d/,
                /\d/
              ]}
            />
          </Col>
          <Col xs={12} sm={6} md={3}>
            <DescriptionField
              label="Razão Social"
              value={fiscal_informations.legal_name}
            />
          </Col>
          <Col xs={12} sm={6} md={3}>
            <DescriptionField label="Apelido" value={company.slug} />
          </Col>
          <Col xs={12} sm={6} md={3}>
            <DescriptionField label="Nome Fantasia" value={company.name} />
          </Col>
        </Row>
        <Row>
          <Col xs={12} sm={6}>
            <DescriptionField
              label="Inscrição Estadual"
              value={fiscal_informations.ie}
            />
          </Col>
          <Col xs={12} sm={6}>
            <DescriptionField
              label="Inscrição Municipal"
              value={fiscal_informations.im}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12} sm={6}>
            <DescriptionField label="Email" value={company.email} />
          </Col>
          <Col xs={12} sm={6}>
            <DescriptionField
              label="Telefone"
              value={(company.phone || "").replace(/\D/g, "")}
              mask={[
                "(",
                /\d/,
                /\d/,
                ")",
                " ",
                /\d/,
                /\d/,
                /\d/,
                /\d/,
                "-",
                /\d/,
                /\d/,
                /\d/,
                /\d/,
                /\d/
              ]}
            />
          </Col>
        </Row>
      </div>
    );
  }
}

export default style(CompanyGeneralInfo);



// WEBPACK FOOTER //
// ./src/components/app/registration/company/view/general-info/index.jsx